const BRAND = {
  name: "Learnlia", // change here only
  shortName: "LL", // change here only
  tagline: "Turn playlists into measurable progress.",
};

export default BRAND;